import axios from '@/app/plugins/Axios';

export default new class ServiceProduto {

  listar(paginacao) {
    return axios.get('produtos', { params: paginacao })
      .then(response => response.data);
  }

  abrir(id) {
    return axios.get('/produtos/' + id)
      .then(response => response.data);
  }

  salvar(produto) {
    return axios.post('/produtos', produto)
      .then(response => response.data);
  }

  atualizar(produto) {
    return axios.put('/produtos/'+ produto.id, produto)
      .then(response => response.data);
  }

  ajustar(produto) {
    return axios.put('/produtos/'+ produto.id + '/ajustar', produto)
      .then(response => response.data);
  }

  excluir(id) {
    return axios.delete('/produtos/' + id)
      .then(response => response.data);
  }

  buscarProdutoPorReferencia(referencia) {
    return axios.get('/produtos/busca?referencia=' + referencia)
      .then(response => response.data);
  }

  buscarProdutoPorDescricao(descricao) {
    return axios.get('/produtos/busca',{ params: descricao})
      .then(response => response.data);
  }

  quantidadeProdutosEstoqueMinimo() {
    return axios.get('/produtos/estoqueminimo')
      .then(response => response.data);
  }
  
  atualizarFornecedorProduto(dados) {
    return axios.put(`/produtos/${dados.produto_id}/atualizarfornecedor`, dados)
      .then(response => response.data);
  }

  entradasProduto(produto_id) {
    return axios.get(`/produtos/${produto_id}/entradas`)
      .then(response => response.data);
  }

  controleProdutos(filtro) {
    return axios.get('controleprodutos', { params: filtro })
      .then(response => response.data);
  }

  fazerPedidoCompra(pedidocompra) {
    return axios.post('pedidoscompra/produtos', pedidocompra)
  }
  
  proximaReferencia() {
    return axios.get('/produtos/proximareferencia')
      .then(response => response.data);
  }

  adicionarVariacao(produto_id, variacao_id) {
    return axios.post(`/produtos/${produto_id}/variacoes`, { variacao_id })
      .then(response => response.data);
  }

  variacoes(produto_id) {
    return axios.get(`/produtos/${produto_id}/variacoes`)
      .then(response => response.data);
  }

  removerVariacao(produto_id, variacao_id) {
    return axios.delete(`/produtos/${produto_id}/variacoes/${variacao_id}`)
      .then(response => response.data);
  }

  reprocessarEstoque(produto_id) {
    return axios.post(`/produtos/${produto_id}/reprocessarestoque`)
      .then(response => response.data);
  }

  gerarReferencia() {
    return axios.post(`produtos/gerar/referencia`)
      .then(response => response.data);
  }

  gerarCodigoBarras(produto) {
    return axios.post(`produtos/gerar/codigobarra`, produto)
      .then(response => response.data);
  }
}
